import { useQuery } from '@tanstack/react-query';

import { queries } from '../common/api/queryKeys/queries';

export const useKeyPortDetails = (keyPortId) => {
    return useQuery(queries.keyPorts.detail(keyPortId));
};
